export const SPECIAL_FIELD_TYPES = ["alertStatusType", "queryEfficiencyRange"];
